<template>
  <div class="build-priority">
    <selector
      :values="values"
      @valueChanged="handleChange"
    ></selector>
  </div>
</template>

<script>
/* eslint-disable  */

import selector from '../inputs/selector';
import { notifyPresets } from './services/notifyPresets';

export default {
  name: 'BuildPriority',
  mixins: [notifyPresets],
  components: {
    selector,
  },
  props: { selected: {}, agentName: {}, bulk: { default: false }, agentsList: {} },
  data() {
    return {
      range: ['HighBuildPriority', 'AboveNormalBuildPriority', 'NormalBuildPriority', 'BelowNormalBuildPriority', 'LowBuildPriority'],
    };
  },
  methods: {
    uniformOrNull(countA, countB) {
      const allA = countA === countB;
      const allB = countA === 0;
      return allA || allB ? allA : null;
    },
    async handleChange(e) {
      this.$emit('change', e.value);
      // if (this.bulk) {
      //   const requestArr = [];
      //   for (const agent of this.agentsList) {
      //     const promise = () => this.$store.dispatch('agents/updateAgent', { action: this.values.action, agentName: agent.Name, value: e.value, agentObj: agent });
      //     requestArr.push(promise);
      //   }
      //   this.postUpdateDialog(requestArr, 'BuildPriority', e.value);
      // } else {
      //   const result = await this.$store.dispatch('agents/updateAgent', { action: this.values.action, agentName: this.values.agentName, value: e.value });
      //   if (result.status === 'OK' || result.Status === 'OK') {
      //     this.notifyPresets.agentBuildPrioritySuccess();
      //   } else {
      //     this.notifyPresets.agentBuildPriorityFail();
      //   }
      // }
    },
  },
  computed: {
    requestData() {
      return this.$store.getters['main/dialogData'].data;
    },
    values() {
      if (this.bulk) {
        const selections = [];
        for (const agent of this.agentsList) {
          if (!selections.includes(agent.BuildPriority)) selections.push(agent.BuildPriority);
          if (selections.length > 1) break;
        }
        return { agentName: this.agentName, action: 'SetBuildPriority', min: 'High', max: 'Low', selected: null, range: this.range };
      }
      return { agentName: this.agentName, action: 'SetBuildPriority', min: 'High', max: 'Low', selected: !isNaN(this.selected) ? this.range[this.selected] : this.selected, range: this.range };
    },
  },
};
</script>

<style lang="scss" scoped>
.build-priority {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
</style>
